import { useLocale, useTranslations } from 'next-intl'

import { TRoomDetail } from '@/entities/room'
import { cn } from '@/shared/lib'

type Props = Pick<TRoomDetail, 'minimumContractWeeks'>

export const MinimumContractPeriod = ({ minimumContractWeeks }: Props) => {
  const locale = useLocale()
  const t = useTranslations()

  const isEnglish = locale === 'en'

  return (
    <dl
      className={cn(
        'typo-body1 flex gap-1 font-normal',
        isEnglish && 'flex-col gap-0',
      )}
    >
      <dt className="text-gray-500">{t('room_detail.minimum_contract')}</dt>
      <dd className="text-gray-900">
        {t('common.week', { week: minimumContractWeeks })}
      </dd>
    </dl>
  )
}
